const userStorageWorker = new Worker(
  new URL('./userStorageWorker.ts', import.meta.url),
  { type: 'module' }
);

export default userStorageWorker;
